// extracted by mini-css-extract-plugin
export default {"pros":"pros-item_pros__Eq3Ul"};